import { put } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, shippingMethodId) => {
    return await put(`/basket/${basketId}/shipping-method/${shippingMethodId}`, []);
};
